import { render, staticRenderFns } from "./ConfigWrap.vue?vue&type=template&id=94d554b2&scoped=true"
import script from "./ConfigWrap.vue?vue&type=script&lang=js"
export * from "./ConfigWrap.vue?vue&type=script&lang=js"
import style0 from "./ConfigWrap.vue?vue&type=style&index=0&id=94d554b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d554b2",
  null
  
)

export default component.exports